import React from "react";
import { Search } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * Floating action button (bottom-right).
 * Default action = navigate to a search page; override with onClick + Icon.
 */
export function FloatingButton({ Icon = Search, onClick, to, label = "Search", testid = "vc-fab" }) {
  const navigate = useNavigate();
  const handle = () => {
    if (onClick) onClick();
    else if (to) navigate(to);
  };
  return (
    <button
      onClick={handle}
      data-testid={testid}
      aria-label={label}
      className="fixed z-40 bottom-[84px] right-4 w-14 h-14 rounded-full bg-gradient-to-br from-emerald-500 to-emerald-600 text-white grid place-items-center shadow-xl shadow-emerald-500/30 hover:scale-110 active:scale-95 transition-transform duration-200"
    >
      <Icon className="w-6 h-6" strokeWidth={2.5} />
    </button>
  );
}
